import React from 'react';
import {connect} from "react-redux";
import './ContentBlock.css'


class Link extends React.Component {

    render() {
        const {media, selectedLanguage} = this.props;
        if (!media.isAllowedForWeb || !media.isLink) return null;

        if (selectedLanguage && selectedLanguage !== media.tags.Language && media.tags.Language !== 'independent') return null;

       const linkMatch = media.tags.LinkUrl.match(/http[s]?:\/\/(.*?)\//);
       const website = linkMatch ? linkMatch[1] : media.tags.LinkUrl;

        return (
            <a target="_blank" rel="noopener noreferrer" className="MediaLink" href={media.tags.LinkUrl}>
                <div className="MediaLinkItem">
                    {
                        media.tags.Description || website
                    }
                </div>
            </a>
        )
    }

}


const mapStateToProps = ({selectedLanguage}) => ({selectedLanguage});
export default connect(mapStateToProps)(Link);
